/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

const locale = {
  placeholder: 'à¤¸à¤®à¤¯ à¤à¤¾ à¤à¤¯à¤¨ à¤à¤°à¥à¤'
};

export default locale;
